export default "__VITE_ASSET__BVwigyEe__"